import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Heading from 'ui/modules/heading'
import Tabs from 'ui/modules/tabs'
import Alert from 'ui/components/alert'
import Filters from './common/filters'
import Search from 'ui/modules/search'
import Actions from './actions'
import CheckboxList from 'ui/modules/lists/checkboxList'
import Pagination from 'ui/components/pagination'
import EmptyStateManager from 'containers/EmptyStateManager'
import useTranslation from 'hooks/useTranslations'

const Vendors = props => {
  const {
    isLoading,
    genericError,
    children,
    totalVendors,
    totalPages,
    currentPage,
    goToPage,
    handleBulkSelect,
    selectedCount,
    errorType,
    handleAddVendor,
    searchOptions,
    filterOptions,
    getSearchOptions,
    clearSearchOptions,
    onSearch,
    onRemoveVendors,
    totalOnPage,
    filters,
    setFilters,
    searchValue,
    setSearchValue,
    canAdd,
    canDelete,
    onCSVExport,
  } = props

  const t = useTranslation()

  const selectedStatus = useMemo(() => {
    if (selectedCount === 0) return 'none'
    if (selectedCount === totalOnPage) return 'full'
    return 'partial'
  }, [selectedCount, totalOnPage])

  return (
    <>
      <Heading
        type="vendors"
        as="h1"
        title={t('vendors')}
        number={totalVendors}
      />
      <Tabs />
      {!isLoading && errorType.type === 'noResults' ? (
        <EmptyStateManager type={errorType.type} action={errorType.action} />
      ) : genericError ? (
        <Box mb={2}>
          <Alert severity="error">{genericError}</Alert>
        </Box>
      ) : (
        <>
          <Search
            placeholder={t('vendors:search-placeholder')}
            searchOptions={searchOptions}
            filterOptions={filterOptions}
            getSearchOptions={getSearchOptions}
            clearSearchOptions={clearSearchOptions}
            onSearch={onSearch}
            value={searchValue}
            setValue={setSearchValue}
            noOptionsText={t('vendors:no-options')}
          />
          {filters ? (
            <Filters filters={filters} setFilters={setFilters} />
          ) : (
            <br />
          )}

          <Box display="flex" flexDirection="column">
            {!isLoading && errorType.type === 'noResultsFilter' ? (
              <EmptyStateManager
                type={errorType.type}
                action={errorType.action}
              />
            ) : (
              <>
                <CheckboxList isLoading={isLoading}>{children}</CheckboxList>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  goToPage={goToPage}
                  showFirstButton
                  showLastButton
                />
              </>
            )}
            <Actions
              status={selectedStatus}
              onBulkSelect={handleBulkSelect}
              canDelete={canDelete && !selectedCount}
              canAdd={canAdd}
              onAddVendor={handleAddVendor}
              onRemoveVendors={onRemoveVendors}
              canDownload={totalPages > 0}
              onCSVExport={onCSVExport}
              hideItemActions={
                !canDelete || errorType.type === 'noResultsFilter'
              }
            />
          </Box>
        </>
      )}
    </>
  )
}

Vendors.propTypes = {
  user: PropTypes.object,
  genericError: PropTypes.bool,
  isLoading: PropTypes.bool,
  totalVendors: PropTypes.number,
  totalPages: PropTypes.number,
  currentPage: PropTypes.number,
  goToPage: PropTypes.func,
  handleBulkSelect: PropTypes.func,
  selectedCount: PropTypes.number,
  errorType: PropTypes.object,
  onRemoveVendors: PropTypes.func,
  totalOnPage: PropTypes.number,
  filters: PropTypes.object,
  setFilters: PropTypes.func,
  showRequirements: PropTypes.bool,
  searchValue: PropTypes.string,
  setSearchValue: PropTypes.func,
  onCSVExport: PropTypes.func,
}

export default Vendors
